import { storeToken } from '../common/auth';
import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';

export async function getUser(language, timeZone) {
  try {
    const data1 = toPascal(await wsRequestGet('/admin/profile/get', language, timeZone));

    // UserEmail = this.UserEmail,
    // UserId = this.UserId,
    // UserName = this.UserName 

    return {
      success: true,
      data: {
        UserEmail: data1.Email,
        UserId: data1.Id,
        UserName: data1.Name
      }
    };
  }
  catch (e) {
    console.error(`unable to get user: ${e}`);
    return {
      success: false
    };
  }
}

export async function loginGoogle(accessToken, providerKey, language, timeZone) {
  const response = await wsRequestPost('/admin/Profile/GoogleLoginAdminWS20', language, timeZone, {
     Token: accessToken
  });

  console.log('login response: ' + JSON.stringify(response));
  if (response.accessToken.token) {
    storeToken({
      Token: response.accessToken.token,
      ExpireAt: response.accessToken.expireAt,
      IsExpired: false,
      AppId: 'Default'
    });
  }
  else {
    console.log(JSON.stringify(response));
    throw new Error('Unable to login');
  }
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}